(function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-portal-link]');
    if (!link) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'portal_nav_click', {
      link_name: link.dataset.portalLink,
      link_location: link.dataset.portalSurface || 'unknown',
      link_url: link.href || ''
    });
  }, true);
})();
